import { Box, Typography } from '@mui/material';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';

import TitleText from '../components/TitleText';

const AccountPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ px: { xs: '1.5rem', md: '3rem' } }}>
            <TitleText title={'MI CUENTA'} />

            <Box
                sx={{
                    border: '1px solid #E6E6E6',
                    borderRadius: '0.5rem',
                    p: { xs: '1rem', md: '1.5rem' },
                    boxShadow: '1px 1px 4px 0px rgba(0, 0, 0, 0.08)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    maxWidth: '42rem'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <LockResetOutlinedIcon sx={{ color: '#FC581F' }} />
                    <Typography sx={{ fontWeight: 'bold', color: '#303030', fontSize: { xs: '1rem', md: '1.125rem' } }}>
                        Seguridad
                    </Typography>
                </Box>

                <Typography sx={{ color: '#575757', fontSize: { xs: '0.875rem', md: '1rem' } }}>
                    Administra la contraseña de tu cuenta.
                </Typography>

                <Box
                    onClick={() => navigate('/admin/account/change-password')}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: '0.75rem',
                        py: '0.875rem',
                        border: '1px solid #F0F0F0',
                        borderRadius: '0.25rem',
                        cursor: 'pointer',
                        '&:hover': {
                            borderColor: '#FC581F'
                        }
                    }}
                >
                    <Typography sx={{ color: '#303030', fontSize: { xs: '0.875rem', md: '1rem' }, fontWeight: 'bold' }}>
                        Cambiar contraseña
                    </Typography>
                    <NavigateNextIcon sx={{ color: '#FC581F' }} />
                </Box>
            </Box>
        </Box>
    );
};

export default AccountPage;
